import * as React from 'react';
import { Route, Routes } from 'react-router';
import Layout from './components/common/Layout';
import HomePage from './features/rss-sites/HomePage';
import RssSitePage from './features/rss-sites/RssSitePage';
import RssFeedPage from './features/rss-feeds/RssFeedPage';
import RssItemPage from './features/rss-items/RssItemPage';
import RssLatestPage from './features/rss-items/RssLatestPage';
import { QueryClient, QueryClientProvider } from 'react-query';
import { AppProvider } from './providers/AppContext';
import './custom.css';

const queryClient = new QueryClient();

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AppProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/site/:siteId?/:slug?" element={<RssSitePage />} />
            <Route path="/feed/:feedId?/:slug?" element={<RssFeedPage />} />
            <Route path="/item/:itemId?/:slug?" element={<RssItemPage />} />
            <Route path="/son-dakika" element={<RssLatestPage />} />
          </Routes>
        </Layout>
      </AppProvider>
    </QueryClientProvider>
  );
}
